import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = { class: "md:flex-row bg-white rounded-xl md:p-0 shadow md:w-auto m-4" }
const _hoisted_4 = { class: "p-2" }
const _hoisted_5 = {
  id: "proveedorProductos",
  class: "stripe hover table-auto"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "ion-text-center" }, "ID"),
  /*#__PURE__*/_createElementVNode("th", { class: "ion-text-center" }, "Nombre"),
  /*#__PURE__*/_createElementVNode("th", { class: "ion-text-center" }, "Teléfono"),
  /*#__PURE__*/_createElementVNode("th", { class: "ion-text-center" }, "Correo electrónico"),
  /*#__PURE__*/_createElementVNode("th", { class: "ion-text-center" }, "Perfil de seguridad"),
  /*#__PURE__*/_createElementVNode("th", { class: "ion-text-center" }, "Modificar"),
  /*#__PURE__*/_createElementVNode("th", { class: "ion-text-center" }, "Activar / Desactivar")
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ion_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterByStatus(true))),
          class: "m-2",
          size: "large",
          color: "light"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Activos")
          ]),
          _: 1
        }),
        _createVNode(_component_ion_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterByStatus(false))),
          class: "m-2",
          size: "large",
          color: "light"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Inactivos")
          ]),
          _: 1
        }),
        _createVNode(_component_ion_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterByStatus(null))),
          class: "m-2",
          size: "large",
          color: "light"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Todos")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOperators, (value, key) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "ion-text-center",
                key: key
              }, [
                (_ctx.filterStatus === null || value.status === _ctx.filterStatus)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("td", null, _toDisplayString(value.operatorKey), 1),
                      _createElementVNode("td", null, _toDisplayString(value.nombre) + " " + _toDisplayString(value.apellido), 1),
                      _createElementVNode("td", null, _toDisplayString(value.telefono), 1),
                      _createElementVNode("td", null, _toDisplayString(value.correo), 1),
                      (value.profileSecurity)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(value.profileSecurity['nombre']), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_8, "Sin Perfil")),
                      _createElementVNode("td", null, [
                        _createVNode(_component_ion_button, {
                          color: "light",
                          onClick: ($event: any) => (_ctx.editOperator(value.operatorKey))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_ion_toggle, {
                          onIonChange: ($event: any) => (_ctx.changeStatus(value.operatorKey, $event)),
                          checked: value.status
                        }, null, 8, ["onIonChange", "checked"])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}